import {
  ADDOREDITPR,
  DELETEPR,
  EDITPRWORO,
  LISTOFITEMCODE,
  LISTOFPR,
  LISTOFPRODUCTSFORITEM,
  LISTOFPROJECT,
  VIEWPR,
  VIEWPRWORO,
} from "./ApiRoutes";
import { authData } from "./services";

export const listOfPR = async (data: object) => {
  const response = await authData.post(LISTOFPR, data);
  return response?.data;
};

export const getViewPR = async (data: object) => {
  const response = await authData.post(VIEWPR, data);
  return response?.data;
};

export const getViewPRWORO = async (data: object) => {
  const response = await authData.post(VIEWPRWORO, data);
  return response?.data;
};

export const listOfItemCode = async (data: object) => {
  const response = await authData.post(LISTOFITEMCODE, data);
  return response?.data;
};

export const listOfProductForItem = async (data: object) => {
  const response = await authData.post(LISTOFPRODUCTSFORITEM, data);
  return response?.data;
};

export const listOfProject = async () => {
  const response = await authData.post(LISTOFPROJECT);
  return response?.data;
};

export const addOrEditPR = async (data: object) => {
  const response = await authData.post(ADDOREDITPR, data);
  return response?.data;
};

export const editPRWORO = async (id: number, data: object) => {
  const response = await authData.put(`${EDITPRWORO}/${id}`, data);
  return response?.data;
};

export const deletePR = async (id: number) => {
  const response = await authData.delete(`${DELETEPR}/${id}`);
  return response?.data;
};
